import { Component, HostListener, OnInit } from '@angular/core';
import { ConfigurazioneGeneraleService } from '../../services/configurazione-generale.service';
import { FormGroup } from '@angular/forms';
import { PaymentnoticesService } from '../../services/paymentnotices.service';
import { SubscriptionManager } from '../../shared/subscription-manager/subscription-manager.class';
import { Documento, PaymentNoticesResponse } from '../../models/payment-notices-response';
import { Router } from '@angular/router';

@Component({
  selector: 'jhi-lista-pagamenti',
  templateUrl: './lista-pagamenti.component.html',
  styleUrls: ['./lista-pagamenti.component.scss']
})
export class ListaPagamentiComponent extends SubscriptionManager implements OnInit {

  countFiltri = 0;
  formFilter!: FormGroup;
  userData = JSON.parse(localStorage.getItem('userData') ?? '{}');
  cdTributo = '';
  paymentNoticesResponse?: PaymentNoticesResponse;
  windowSize: number;
  loading = false;

  constructor(private configurazioneGeneraleService: ConfigurazioneGeneraleService, private paymentNoticesServices: PaymentnoticesService, private router: Router) {
    super();
    this.windowSize = window.innerWidth;
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any): void {
    this.windowSize = event.target.innerWidth;
  }

  ngOnInit(): void {
    this.getPaymentNotices();
  }

  goToHome():void{
    window.location.href = this.configurazioneGeneraleService.configurazione.linkHome;
  }

  getPaymentNotices():void{
    this.subs.sink = this.paymentNoticesServices.getPaymentNotices(this.initPaymentNotices()).subscribe({
      next: (res) => {
        this.paymentNoticesResponse = res;
        this.paymentNoticesResponse.mandatiPagamento = this.paymentNoticesResponse.mandatiPagamento.map(pg => {
          let stato;
          if (pg.Importo === pg.Pagamenti) {
            stato = 'Pagato';
          } else if (pg.Rate && pg.Rate[0].ImportoRidotto != null && pg.Rate[0].ImportoRidotto == pg.Pagamenti) {
            stato = 'Pagato';
          } else if(pg.Importo - pg.Pagamenti <= 0 ){
            stato = 'Pagato';
            pg.Importo = pg.Pagamenti;
          }else {
            stato = 'Da Pagare';
          }
          return Object.assign({}, pg, {
            stato
          })
        })
      }
    })
  }

  initPaymentNotices(): any{
    return {
      //codiceFiscale: 'CSTSFN57A16C342G',
      codiceFiscale: <string> this.userData.cf,
      codiceTributo: this.cdTributo
    }
  }

  removeFilters():void{

  }

  goToPagamento(pagamento: Documento):void{
    let cdTributo = this.getByValue(this.paymentNoticesServices.mapCodiceTributo, pagamento.Tributo);
    void this.router.navigate(["Servizi/PagamentoTributi/" + cdTributo + "/" + pagamento.Numero]);
  }

  getByValue(map: any, searchValue: string): any {
    for (let [key, value] of map.entries()) {
      if (value === searchValue)
        return key;
    }
  }
}
